interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

const baseSchemas = {
  Organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '樱花动漫',
    url: 'https://www.sakura-anime.com',
    logo: 'https://www.sakura-anime.com/logo.png',
    description: '樱花动漫网是一个专注于动漫的网站，让您在线观看高清动漫，无需注册或订阅，即可访问大量优质内容。',
    email: 'contact@sakura-anime.com',
    sameAs: [
      'https://weibo.com/sakuraanime',
      'https://space.bilibili.com/sakuraanime',
    ],
  },
  WebSite: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '樱花动漫',
    url: 'https://www.sakura-anime.com',
    description: '樱花动漫网 - 在线观看高清动漫，专注动漫的网站，提供海量优质动漫内容。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://www.sakura-anime.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  },
};

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  let schema: Record<string, unknown>;

  if (type === 'Organization' || type === 'WebSite') {
    schema = baseSchemas[type];
  } else if (data) {
    schema = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    };
  } else {
    return null;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}